import { cva } from "class-variance-authority";

export { default as Badge } from "./Badge.vue";
export { default as ClickableBadge } from "./ClickableBadge.vue";
export { default as IconBadge } from "./IconBadge.vue";
export { default as RemovableBadge } from "./RemovableBadge.vue";
export { default as UserBadge } from "./UserBadge.vue";

export const types = ["private", "recurring"];

export const badgeVariants = cva(
    "inline-flex items-center justify-center gap-1 whitespace-nowrap border-primary rounded-md",
    {
        variants: {
            variant: {
                default: "py-1 px-2.5 bg-white border",
                icon: "p-1.5 rounded-sm",
                filter: "flex flex-nowrap items-center bg-white hover:bg-gray-50 rounded-md text-utility-gray-700 gap-1.5 p-1.5 text-sm font-medium cursor-pointer border border-utility-gray-300 shadow-sm",
            },
            type: {
                default:
                    "text-sm leading-5 font-medium text-utility-gray-700 [&_#icon]:text-utility-gray-500",
                private: "bg-utility-gray-light-100 text-utility-gray-600",
                recurring:
                    "bg-utility-blue-light-100 text-utility-blue-light-500",
            },
        },
        defaultVariants: {
            variant: "default",
            type: "default",
        },
    }
);
